import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { RxTemplate } from '@shared/rx-templates/rx-template.model';
import { ProcedureMap } from '@shared/models/procedure-map';
import { ISectionDirtyCheckService } from '@shared/models/section-dirty-check';
import { NotesQuery } from './state/notes-query';
import { isNotesVisibleForSendTo } from '@shared/services/sections-visibility.tokens';
import { RxTemplateService } from '@shared/rx-templates/rx-template.service';

@Injectable({ providedIn: 'root' })
export class NotesDirtyCheckService implements ISectionDirtyCheckService {
	constructor(
		private readonly notesQuery: NotesQuery,
		private readonly rxTemplateService: RxTemplateService
	) {}

	willLoseDataFor$(targetTemplate: Readonly<RxTemplate>, _targetProcedureMap: ProcedureMap | null): Observable<boolean> {
		if (!isNotesVisibleForSendTo(this.rxTemplateService.currentTemplate) || isNotesVisibleForSendTo(targetTemplate)) {
			return of(false);
		}

		const s = this.notesQuery.getValue();

		return of((s.notes != null && s.notes !== '') || (s.notesArray != null && s.notesArray.length > 0));
	}
}
